import axiosWithMjrAccessToken from 'utils/axiosWithMjrAccessToken';
import { logError } from 'utils/errorLogger';

/**
 * Verifies the address the customer inputs on the registration form.
 *
 * @param data - registration form data
 *
 */
export const VerifyAddress = async (data) => {
  const VerifyAddressUrl = `${process.env.NEXT_PUBLIC_PROXY_MJR_API_URL}/api/Shipping/VerifyAddress`;
  const VerifyAddressData = {
    addressLine1: data.addressLine1,
    addressLine2: data.addressLine2,
    city: data.city,
    state: data.state,
    zipCode: data.zipCode,
    country: data.country || process.env.NEXT_PUBLIC_US_ISO_CODE,
  };
  const VerifyAddressResponse = await axiosWithMjrAccessToken
    .post(VerifyAddressUrl, VerifyAddressData)
    .then((response) => response)
    .catch((error) => {
      logError(error, 'VerifyAddress - /utils/verifyAddress.js');
      return error;
    });
  return VerifyAddressResponse;
};
